import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import BadgeUI from '../../../widgets/output/BadgeUI'
import CardUI from '../../../widgets/layout/CardUI'
import openAILite from '../../../assets/finapp/openai-lite.png'
import openAIDark from '../../../assets/finapp/openai-dark.png'
import UserContactUpdateModalSF from '../../../components/superUser/account/UserContactUpdateModalSF.js'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF.js'
import { Link } from 'react-router-dom'
import { colors } from 'react-select-v2/lib/theme.js'
import DINNumberUpdateModalSF from './DINNumberUpdateModalSF.js'
import UserPhoneNumberUpdateModalSF from './UserPhoneNumberUpdateModalSF.js'
const KYCUserListUI = ({ context, account, accountUserList, selectedUserId, updateMode, onUpdateClick, onUpdateCancel, onRefreshClick,
  copyToClipboardText, onCopyToClipboard,
  fileUploadMode, onUpdateAadhaarClick,
  onFileUploadClick, onfileUploadCancel, onfileUpload,
  fileBackUploadMode,
  onfileBackUploadClick, onfileBackUploadCancel, onfileBackUpload,
  selectedAadhaarUserId, onDINUpdateClick, onDINUpdateCancelClick, updateDINMode,
  onPhoneNumberUpdateClick, onPhoneNumberUpdateCancelClick, updatePhoneNumberMode,
  onFetchPhoneNumberClick, fetchingPhoneNumberUserId
}) => {

  const selectedUser = accountUserList.find(user => user.userId === selectedUserId);

  return (
    <div className='su_accusr g_m_top_50'>
      {
        accountUserList.filter(u => u.dinNumber).map((user, i) =>
          <AccountUsers context={context} key={i} i={i} user={user} updateMode={updateMode} onUpdateClick={onUpdateClick} onUpdateAadhaarClick={onUpdateAadhaarClick}
            copyToClipboardText={copyToClipboardText} onCopyToClipboard={onCopyToClipboard} account={account} onFileUploadClick={onFileUploadClick}
            fileUploadMode={fileUploadMode} onfileUploadCancel={onfileUploadCancel} onfileUpload={onfileUpload}
            fileBackUploadMode={fileBackUploadMode} onfileBackUploadClick={onfileBackUploadClick} onfileBackUploadCancel={onfileBackUploadCancel}
            onfileBackUpload={onfileBackUpload} onDINUpdateClick={onDINUpdateClick} updateDINMode={updateDINMode}
            onPhoneNumberUpdateClick={onPhoneNumberUpdateClick}
            onFetchPhoneNumberClick={onFetchPhoneNumberClick}
            fetchingPhoneNumberUserId={fetchingPhoneNumberUserId}
          />
        )
      }

      {
        accountUserList.filter(u => !u.dinNumber).map((user, i) =>
          <AccountUsers context={context} key={i} i='1' user={user} account={account} onUpdateClick={onUpdateClick} onUpdateAadhaarClick={onUpdateAadhaarClick}
            copyToClipboardText={copyToClipboardText} onCopyToClipboard={onCopyToClipboard} onFileUploadClick={onFileUploadClick}
            fileUploadMode={fileUploadMode} onfileUploadCancel={onfileUploadCancel} onfileUpload={onfileUpload}
            fileBackUploadMode={fileBackUploadMode} onfileBackUploadClick={onfileBackUploadClick} onfileBackUploadCancel={onfileBackUploadCancel}
            onfileBackUpload={onfileBackUpload} selectedAadhaarUserId={selectedAadhaarUserId}
            onPhoneNumberUpdateClick={onPhoneNumberUpdateClick}
            onFetchPhoneNumberClick={onFetchPhoneNumberClick}
            fetchingPhoneNumberUserId={fetchingPhoneNumberUserId}
          />
        )
      }
      <UserContactUpdateModalSF context={context} updateMode={updateMode} selectedUserId={selectedUserId} onCancelClick={onUpdateCancel}
        onRefreshClick={onRefreshClick} />
      {selectedUser && (
        <DINNumberUpdateModalSF
          context={context}
          account={account}
          updateMode={updateDINMode}
          selectedUser={selectedUser}
          selectedUserId={selectedUserId}
          onCancelClick={onDINUpdateCancelClick}
          onRefreshClick={onRefreshClick}
        />
      )}
      {selectedUser && (
        <UserPhoneNumberUpdateModalSF
          context={context}
          account={account}
          updateMode={updatePhoneNumberMode}
          selectedUser={selectedUser}
          selectedUserId={selectedUserId}
          onCancelClick={onPhoneNumberUpdateCancelClick}
          onRefreshClick={onRefreshClick}
        />
      )}
    </div>
  );
}

const AccountUsers = ({ context, i, user, account, copyToClipboardText, onCopyToClipboard, onUpdateClick,
  fileUploadMode, onUpdateAadhaarClick,
  onFileUploadClick, onfileUploadCancel, onfileUpload,
  fileBackUploadMode,
  onfileBackUploadClick, onfileBackUploadCancel, onfileBackUpload,
  selectedAadhaarUserId, onDINUpdateClick, onPhoneNumberUpdateClick, onFetchPhoneNumberClick, fetchingPhoneNumberUserId
}) => {
  
  const isDINAlphanumeric = (din) => {
    if (!din) return false;
    return /^[a-zA-Z0-9]+$/.test(din);
  };

  return (
  <CardUI className={`${i ? 'g_m_top_100' : ''}`}
    title={
      <span className='g_flex_h'>
        {user.name}
        <span className='icon icon-pencil' data-user-id={user.userId} onClick={onUpdateClick} />
      </span>
    }>
    {
      user.aiDesc &&
      <div className='g_flex_h g_flex_top g_m_bottom_100'>
        <img src={context.theme === 'lite' ? openAILite : openAIDark} alt="" width='20px' />
        <span className='g_m_left_50'>{user.aiDesc}</span>
      </div>
    }

    <div>
      <div className='g_flex_h g_flex_top'>
        <span className='g_flex_v'>
          <span>
            PAN: {user.panNumber}<br />
            {user.panFullName}<br />
            Phone: {user.phoneNumber || 'Not provided'} <span className='icon icon-pencil' data-user-id={user.userId} onClick={onPhoneNumberUpdateClick} />
            {
              !user.phoneNumber && user.dinNumber && isDINAlphanumeric(user.dinNumber) && (
                <button
                  className="surepass-phone-btn"
                  onClick={() => onFetchPhoneNumberClick(user.userId)}
                  title="Get Phone By Surepass"
                  disabled={fetchingPhoneNumberUserId === user.userId}
                >
                  {fetchingPhoneNumberUserId === user.userId ? (
                    <>
                      <span className="icon icon-spinner icon-spin"></span>
                      Fetching...
                    </>
                  ) : (
                    'Fetch Phone Number'
                  )}
                </button>
              )
            }
            <br />
            {user.panDob}
          </span>
          <span className='g_m_top_50'>
            Aadhaar: {user.aadhaarNumber}<br />
            {user.aadhaarFullName}

            {
              !user.aadhaarNumber &&
              <span>
                <Link to="#" className="g_m_left_50 g_cursor_pointer g_muted" onClick={onUpdateAadhaarClick} data-aadhaar-user-id={user.userId}
                >Upload Aadhaar Front</Link>

                <Link to="#" className="g_m_left_50 g_cursor_pointer g_muted" onClick={onfileBackUploadClick} data-aadhaar-user-id={user.userId}
                >Upload Aadhaar Back</Link>
                <FileUploadModalSF
                  context={context}
                  uploadMode={fileUploadMode}
                  onCancelClick={onfileUploadCancel}
                  titleLabel={'Upload Aadhaar Front'}
                  signedUrlApi={`/api/su/accounts/${account.accountId}/users/${selectedAadhaarUserId}/aadhaar/front/fileUploadSignedUrl`}
                  onUpload={onfileUpload}
                  multiple={false}
                />
                <FileUploadModalSF
                  context={context}
                  uploadMode={fileBackUploadMode}
                  onCancelClick={onfileBackUploadCancel}
                  titleLabel={'Upload Aadhaar Back'}
                  signedUrlApi={`/api/su/accounts/${account.accountId}/users/${selectedAadhaarUserId}/aadhaar/back/fileUploadSignedUrl`}
                  onUpload={onfileUpload}
                  multiple={false}
                />
              </span>
            }
          </span>
        </span>
        <span className='g_flex_v'>
          <span>
            DIN: {user.dinNumber} <span className='icon icon-pencil' data-user-id={user.userId} onClick={onDINUpdateClick} /><br />
            {user.dinFullName}<br />
            {user.dinEmail && <span>{user.dinEmail}</span>}
            {user.dinAddress && <span>{user.dinAddress}</span>}
          </span>

          <span className='g_flex_v g_m_top_50'>
            Shareholding: {user.shareholdingPercent}%
            <span>
              Gross salary:
              {
                user.grossSalary &&
                <>
                  {user.grossSalaryYear} {user.grossSalary}
                </>
              }
            </span>
            <span>Gender: {user.gender}</span>
            <span>CIBIL score: {user.cibilScore || 'Not available'}</span>
          </span>
        </span>
      </div>


      <div className='g_flex_v g_m_top_50'>
        <span>{user.email}</span>
        <span>{user.userId}
          <CopyToClipboard text={user.userId}
            onCopy={onCopyToClipboard}>
            <span className='g_m_left_50 icon icon-clone g_cursor_pointer' />
          </CopyToClipboard>
          {
            copyToClipboardText === user.userId &&
            <span className='g_m_left_50'>copied</span>
          }
        </span>
      </div>
    </div>

    <div className='g_flex_h g_flex_top'>
      <span>
      </span>
      <span>
        {
          user.kycCompleted &&
          <span><BadgeUI label='kyc complete' /></span>
        }
        {
          user.dinNumber &&
          <span className='g_m_left_50'><BadgeUI label='director' /></span>
        }
        <span className='g_m_left_50'><BadgeUI label={user.roleName} /></span>
      </span>
    </div>

  </CardUI>
  );
};


export default KYCUserListUI
